<p-toast></p-toast>

<!-- ===== Brand / Logo area ===== -->
<header class="brand">
  <div class="brand__logo-wrapper">
    <img class="brand__logo" [src]="logoUrl" alt="Brand logo" />
  </div>

  <!-- Environment-based subtitle -->
  @if (env === 'dqvademecum') {
    <p-chip class="brand__chip" label="dq VADEMECUM" icon="pi pi-sparkles"></p-chip>
  } @else if (env === 'ava' || env === 'avafitogest') {
    <p-chip class="brand__chip" label="Associació Valenciana d'Agricultors" icon="pi pi-users"></p-chip>
  }
</header>

<!-- ===== Main Auth Section ===== -->
<section class="auth">

  <p-card class="rec__card">
    <ng-template pTemplate="header">
      <div class="rec__header">
        <h1 class="rec__title">
          <i class="pi pi-key mr-2" style="color: var(--primary)"></i>
          Recuperar contraseña
        </h1>
      </div>
    </ng-template>

    <div class="rec__body">
      <p-steps [model]="steps" [activeIndex]="activeIndex" styleClass="w-8 h-8 p-0 rec__steps"></p-steps>

      <!-- STEP 1: EMAIL -->
      <section *ngIf="activeIndex === 0" class="rec__section">
        <label for="rec-email" class="rec__label">Email</label>
        <div class="p-inputgroup d-flex">
          <input id="rec-email"
                pInputText
                [formControl]="emailCtrl"
                placeholder="direccion@email.com"
                (keydown.enter)="sendEmail()" />
        </div>
        <div class="rec__errors">
          <p-message *ngIf="emailCtrl.touched && emailCtrl.hasError('required')"
                    severity="error" text="El email es obligatorio"></p-message>
          <p-message *ngIf="emailCtrl.touched && emailCtrl.hasError('email')"
                    severity="warn" text="El formato de email no es válido"></p-message>
        </div>
        <div class="rec__hint">Recibirá un código para generar una nueva contraseña.</div>

        <div class="rec__actions">
          <p-button
            icon="pi pi-arrow-left"
            label="Volver"
            styleClass="p-button-outlined p-button-secondary p-button-rounded"
            (onClick)="goBack()">
          </p-button>
          <p-button
            [loading]="sendingEmail"
            icon="pi pi-send"
            label="Enviar email"
            (onClick)="sendEmail()"
            styleClass="p-button-success p-button-rounded">
          </p-button>
        </div>
      </section>

      <!-- STEP 2: CODE -->
      <section *ngIf="activeIndex === 1" class="rec__section">
        <p-divider align="center"><b>Código de verificación</b></p-divider>

        <label for="otp" class="rec__label">Código</label>
        <!-- PrimeNG 19: InputOtp -->
        <p-inputOtp
          inputId="otp"
          [length]="8"
          [integerOnly]="false"
          [formControl]="codeCtrl"
          (onComplete)="verifyCode()"
          placeholder="#"
          styleClass="rec__otp">
        </p-inputOtp>

        <div class="rec__actions rec__actions--split">
          <p-button
            icon="pi pi-arrow-left"
            label="Volver"
            styleClass="p-button-outlined p-button-secondary p-button-rounded"
            (onClick)="activeIndex = 0">
          </p-button>

          <div class="rec__resend">
            <p-button
              icon="pi pi-refresh"
              label="Reenviar"
              [disabled]="resendIn > 0 || sendingEmail"
              (onClick)="resend()"
              styleClass="p-button-text">
            </p-button>
            <small *ngIf="resendIn > 0">Podrás reenviar en {{resendIn}}s</small>
          </div>

          <p-button
            [loading]="verifying"
            icon="pi pi-check"
            label="Validar código"
            (onClick)="verifyCode()"
            styleClass="p-button-success p-button-rounded">
          </p-button>
        </div>

        <div class="rec__errors">
          <p-message *ngIf="codeCtrl.touched && codeCtrl.hasError('required')"
                    severity="error" text="El código es obligatorio"></p-message>
          <p-message *ngIf="codeCtrl.touched && codeCtrl.hasError('pattern')"
                    severity="warn" text="Introduce 6 dígitos"></p-message>
        </div>
      </section>

      <!-- STEP 3: NEW PASSWORD -->
      <section *ngIf="activeIndex === 2" class="rec__section">
        <p-divider align="center"><b>Nueva contraseña</b></p-divider>

        <div class="grid">
          <div class="col-12 md:col-6">
            <label for="newpass" class="rec__label">Contraseña</label>
            <p-password
              inputId="newpass"
              [formControl]="passwordCtrl"
              [toggleMask]="true"
              [feedback]="true"
              promptLabel="Escribe una contraseña"
              weakLabel="Débil"
              mediumLabel="Media"
              strongLabel="Fuerte"
              styleClass="w-full">
            </p-password>

            <div class="rec__errors">
              <p-message *ngIf="passwordCtrl.touched && passwordCtrl.hasError('required')"
                        severity="error" text="Obligatoria"></p-message>
              <p-message *ngIf="passwordCtrl.touched && passwordCtrl.hasError('minlength')"
                        severity="warn" text="Mínimo 8 caracteres"></p-message>
              <p-message *ngIf="passwordCtrl.touched && passwordCtrl.hasError('weak')"
                        severity="warn" text="Usa mayúsculas, minúsculas y números"></p-message>
            </div>
          </div>

          <div class="col-12 md:col-6 mt-3">
            <label for="repeat" class="rec__label">Repite la contraseña</label>
            <p-password
              inputId="repeat"
              [formControl]="repeatCtrl"
              [toggleMask]="true"
              [feedback]="false"
              styleClass="w-full"
              (keydown.enter)="changePassword()">
            </p-password>

            <div class="rec__errors">
              <p-message *ngIf="repeatCtrl.touched && repeatCtrl.hasError('required')"
                        severity="error" text="Obligatoria"></p-message>
              <p-message *ngIf="passwordForm.touched && passwordForm.errors?.['passwordsNotEqual']"
                        severity="error" text="Las contraseñas no coinciden"></p-message>
            </div>
          </div>
        </div>

        <div class="rec__actions">
          <p-button
            icon="pi pi-check-circle"
            label="Cambiar contraseña"
            [loading]="changing"
            [disabled]="passwordForm.invalid"
            (onClick)="changePassword()"
            styleClass="p-button-success p-button-rounded">
          </p-button>
        </div>
      </section>
    </div>
  </p-card>
</section>